import React, {Component} from 'react';
import Button from "@material-ui/core/es/Button";
import DialogActions from "@material-ui/core/es/DialogActions";
import Dialog from "@material-ui/core/es/Dialog";
import DialogContent from "@material-ui/core/es/DialogContent";
import DialogContentText from "@material-ui/core/es/DialogContentText";
import {connect} from "react-redux";
import {closeInformationModal} from "./InformationModalActions";

class InformationModal extends Component {

    render() {
        const {closeInformationModal, informationModal: {text, open}} = this.props;
        return (
            <Dialog open={open} onClose={closeInformationModal} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <DialogContentText>
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeInformationModal} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = ({informationModal}) => ({informationModal});

export default connect(mapStateToProps, {closeInformationModal})(InformationModal);



// WEBPACK FOOTER //
// ./src/components/information-modal/InformationModal.js